export default __webpack_public_path__ + "static/media/YAS0120.34I-27680_-16617_0.94dec910.jpg";